import { UPSPACE_FULL_PATH } from 'utils/constants/externalLinks'
import { functionCall, functions } from 'utils/firebase'

import {
  LinkType,
  StripeAccount,
  StripeAccountLink,
  StripeCheckoutSessionInput,
  StripeCustomer,
  StripeGeneratedLink,
  StripeProgramInput,
} from 'types/stripe'

export const fetchAccount = async () => {
  const fetchStripeAccount = functionCall<undefined, StripeAccount>(functions, 'getStripeAccount')
  const account = await fetchStripeAccount()
  return account.data
}

export const fetchCustomer = async () => {
  const fetchStripeCustomer = functionCall<undefined, StripeCustomer>(
    functions,
    'getStripeCustomer',
  )

  const customer = await fetchStripeCustomer()
  return customer.data
}

export const fetchAccountLink = async (linkType: LinkType) => {
  const fetchStripeAccountLink = functionCall<
    { basePath: string; linkType: string },
    StripeAccountLink
  >(functions, 'getStripeAccountLink')
  const accountLink = await fetchStripeAccountLink({
    basePath: UPSPACE_FULL_PATH,
    linkType,
  })
  return accountLink.data
}

export const fetchCustomerPortalLink = async () => {
  const fetchStripeCustomerPortalLink = functionCall<{ basePath: string }, StripeGeneratedLink>(
    functions,
    'getStripeCustomerPortalLink',
  )
  const customerPortalLink = await fetchStripeCustomerPortalLink({
    basePath: UPSPACE_FULL_PATH,
  })
  return customerPortalLink.data
}

export const createStripeProgram = async (data: StripeProgramInput) => {
  const stripeProgram = functionCall<StripeProgramInput, undefined>(
    functions,
    'createStripeProduct',
  )
  const stripeResponse = await stripeProgram(data)
  return stripeResponse.data
}

export const fetchStripeProgramPrices = async (programId?: string) => {
  if (!programId) return null

  const stripeProgramPrices = functionCall<{ programId: string }, undefined>(
    functions,
    'getStripeProgramPrices',
  )
  const stripeResponse = await stripeProgramPrices({ programId })
  return stripeResponse.data
}

export const createStripeCheckoutSession = async ({
  priceId,
  trainerId,
}: {
  priceId: string
  trainerId: string
}) => {
  const fetchStripeCheckoutSession = functionCall<StripeCheckoutSessionInput, StripeGeneratedLink>(
    functions,
    'getStripeCheckoutLink',
  )

  const stripeResponse = await fetchStripeCheckoutSession({
    basePath: UPSPACE_FULL_PATH,
    priceId,
    trainerId,
  })

  return stripeResponse.data
}
